import request from '../utils/request';

export function getBanks(params) {
    return request.get('/banks', {params});
}

export function getBank(bankId) {
    return request.get(`/banks/${bankId}`);
}

export function createBank(data) {
    return request.post(`/banks`, data);
}

export function updateBank(bankId, data) {
    return request.put(`/banks/${bankId}`, data);
}

export function deleteBank(bankId) {
    return request.delete(`/banks/${bankId}`);
}
